export default __webpack_public_path__ + "static/media/stomach-care.897f2014.png";